import { render, staticRenderFns } from "./multilineText.vue?vue&type=template&id=18282394"
import script from "./multilineText.vue?vue&type=script&lang=js"
export * from "./multilineText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports